var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleBroken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23c6.075 0 11-4.925 11-11 0-1.717-.393-3.342-1.095-4.79-.28-.577-1.038-.66-1.49-.208l-7.707 7.715a1 1 0 01-1.415 0l-3-3a1 1 0 111.414-1.414L12 12.595l7.386-7.393c.38-.38.394-.997-.004-1.358A10.96 10.96 0 0012 1C5.925 1 1 5.925 1 12s4.925 11 11 11z",
    fill: "#000"
  })));
}
export default SvgCheckCircleBroken;